export type SupportedLocale = "en" | "pt-BR" | "es" | "fr" | "de" | "it" | "zh" | "ja";

export const DEFAULT_LOCALE: SupportedLocale = "en";

export function resolveSupportedLocale(teamsLocale?: string | null): SupportedLocale {
  const normalized = (teamsLocale || "").trim().toLowerCase();
  if (normalized.startsWith("pt")) return "pt-BR";
  if (normalized.startsWith("es")) return "es";
  if (normalized.startsWith("fr")) return "fr";
  if (normalized.startsWith("de")) return "de";
  if (normalized.startsWith("it")) return "it";
  if (normalized.startsWith("zh")) return "zh";
  if (normalized.startsWith("ja")) return "ja";
  return DEFAULT_LOCALE;
}

// Idiomas suportados pelo softphone embarcado.
export type SoftphoneLanguage = "pt_BR" | "en_US" | "es";

// Mapeia o locale da aplicação para um dos idiomas do softphone. Qualquer
// idioma suportado pelo app que não seja pt-BR ou es cai em en_US.
export function resolveSoftphoneLanguage(locale: SupportedLocale): SoftphoneLanguage {
  if (locale === "pt-BR") return "pt_BR";
  if (locale === "es") return "es";
  return "en_US";
}
